// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__Od12R","copy":"footer_copy__balSt","CW_block":"footer_CW_block__fOTAT"};